// extracted by mini-css-extract-plugin
export default {"container":"StatRow_container__v6zNh","alignRight":"StatRow_alignRight__P4zrB"};